import { useAuth } from "@/contexts/AuthContext";
import { useDemo } from "@/contexts/DemoContext";

export type AppRole = "owner" | "admin" | "agent" | "branch_manager" | null;

export function normalizeRole(role: string | null | undefined): AppRole {
  if (role === "owner" || role === "admin" || role === "agent" || role === "branch_manager") {
    return role;
  }
  return null;
}

export function useRoleAccess() {
  const { profile } = useAuth();
  const { isDemo, demoRole } = useDemo();

  const role = normalizeRole(isDemo ? demoRole : profile?.role);
  const isOwner = role === "owner";
  const isAdmin = isOwner || role === "admin";
  const canManageFleet = isAdmin;
  const canManageCustomers = isAdmin || role === "agent";
  const canManageMaintenance = isAdmin || role === "agent";

  return {
    role,
    isOwner,
    isAdmin,
    canManageFleet,
    canManageCustomers,
    canManageMaintenance,
  };
}
